import { render, staticRenderFns } from "./account-container.vue?vue&type=template&id=e5a1d97c"
import script from "./account-container.vue?vue&type=script&lang=js"
export * from "./account-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5a1d97c')) {
      api.createRecord('e5a1d97c', component.options)
    } else {
      api.reload('e5a1d97c', component.options)
    }
    module.hot.accept("./account-container.vue?vue&type=template&id=e5a1d97c", function () {
      api.rerender('e5a1d97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/settings/account/components/account-container.vue"
export default component.exports